const TOOLTIP_INJECTION_KEY = /* @__PURE__ */ Symbol("elTooltip");

export { TOOLTIP_INJECTION_KEY };
//# sourceMappingURL=constants.mjs.map
